import React from 'react';

export interface IDeviceType {
    isMobile: boolean;
}

export const DeviceTypeContext = React.createContext<IDeviceType>({ isMobile: false });
